import { isInRange } from "./isInRange";

import { WordRange } from "../types";

export function wordInRanges(ranges: WordRange[], index: number): boolean {
  return !!ranges.find((range) => isInRange(range, index));
}
